import AlertType from 'common/types/AlertType';
import React from 'react';
import AlertIcon, { IAlertIcon } from './AlertIcon';

interface IAlert {
  type: AlertType;
  children?: React.ReactNode;
  noIcon?: boolean;
  iconSize?: IAlertIcon['size'];
  indent?: boolean;
}

const Alert = (props: IAlert) => {
  const iconSize = props.iconSize || 'sm';
  return (
    <div className={`alert alert-${props.type} d-flex`}>
      {props.noIcon !== true && <AlertIcon type={props.type} size={iconSize} />}
      {props.indent ? <div className="alert-content">{props.children}</div> : props.children}
    </div>
  );
};

export default Alert;
